/* Sticky bottom cart bar: shows a persistent summary (icon + count,
   thumbnails, running total, "View cart") whenever the cart has items.
   Refreshes via the theme's existing PUB_SUB_EVENTS.cartUpdate event
   (published by product-form.js on add, the card quantity stepper, and
   the cart drawer's own quantity changes) so it always reflects the
   current cart without needing its own polling. "View cart" opens the
   existing cart-notification drawer - it does not navigate away. */
(function () {
  if (customElements.get("sticky-cart-bar")) return;

  customElements.define(
    "sticky-cart-bar",
    class StickyCartBar extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector(".sticky-cart-bar__view-cart");
        this.countEl = this.querySelector(".sticky-cart-bar__count");
        this.thumbsEl = this.querySelector(".sticky-cart-bar__thumbs");
        this.totalEl = this.querySelector(".sticky-cart-bar__total-value");

        if (this.button) {
          this.button.addEventListener("click", () => {
            const notification = document.querySelector("cart-notification");
            if (notification && typeof notification.open === "function") {
              // open() attaches a "click outside closes it" listener on
              // document.body synchronously. Calling it directly inside
              // this click handler means that same click event (still
              // bubbling) immediately reaches the new listener and closes
              // it again. Defer to the next tick so it opens and stays open.
              setTimeout(() => notification.open(), 0);
            }
          });
        }

        this.refresh();

        if (typeof subscribe === "function") {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      refresh() {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((response) => response.json())
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      render(cart) {
        if (!cart || !cart.item_count) {
          this.setAttribute("hidden", "");
          return;
        }

        this.removeAttribute("hidden");
        if (this.countEl) this.countEl.textContent = cart.item_count;
        if (this.totalEl) {
          this.totalEl.textContent = this.formatMoney(
            cart.total_price,
            cart.currency
          );
        }

        if (this.thumbsEl) {
          this.thumbsEl.innerHTML = "";
          const maxThumbs = 3;
          cart.items.slice(0, maxThumbs).forEach((item) => {
            if (!item.image) return;
            const img = document.createElement("img");
            img.src = item.image.replace(
              /(\.[a-zA-Z0-9]+)(\?.*)?$/,
              "_80x80$1$2"
            );
            img.alt = item.product_title || "";
            img.loading = "lazy";
            img.className = "sticky-cart-bar__thumb";
            this.thumbsEl.appendChild(img);
          });

          if (cart.items.length > maxThumbs) {
            const more = document.createElement("span");
            more.className = "sticky-cart-bar__thumb-more";
            more.textContent = "+" + (cart.items.length - maxThumbs);
            this.thumbsEl.appendChild(more);
          }
        }
      }

      formatMoney(cents, currency) {
        try {
          return new Intl.NumberFormat(undefined, {
            style: "currency",
            currency: currency || "USD",
          }).format((cents || 0) / 100);
        } catch (e) {
          return "$" + ((cents || 0) / 100).toFixed(2);
        }
      }
    }
  );
})();
